import RoomInfoRequest from '../../../../../project-manager/files/i-services/models/request/RoomInfoRequest';

/**
 * * Модель запроса на отправку фрагмента видео
 */
export default class SendVideoChunkRequest  {
	/**
	 * * Номер файла
	 */
	VideoId!: string;
	/**
	 * * Номер файла
	 */
	FileId!: number;
	/**
	 * * Фрагмент видео
	 */
	VideoChunk!: string;
	/**
	 * * Последний ли чанк
	 */
	IsLast: boolean = false;
	/**
	 * * Информация о комнате куда нужно отправить событие
	 */
	Room!: RoomInfoRequest;
	constructor(obj?: Partial<SendVideoChunkRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
